import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { formDataFormatter } from '~/shared/utils';

const STATUS_CHOICES = {
    IDLE: 0,
    WAITING: 1,
    SUCCESS: 2,
    ERROR: 3,
};

const RegisterApp = (props) => {
    const [status, setStatus] = useState({
        type: STATUS_CHOICES.IDLE,
        messages: {}
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = formDataFormatter("form[name=credentials]");
        setStatus({ ...status, ...{ type: STATUS_CHOICES.WAITING }});
        $.post(
            props.registerApiEndpoint,
            data,
            (response) => {
                setStatus({
                    ...status,
                    ...{
                        type: STATUS_CHOICES.SUCCESS,
                        messages: response.messages
                    }
                });
            }
        ).fail((response) => {
            setStatus({
                ...status,
                ...{
                    type: STATUS_CHOICES.ERROR,
                    messages: response.responseJSON.messages
                }
            });
        });
    };
    
    return <>
            <div className = 'content-section p-5'>
                <h3 className ='text-light'>Register</h3>
                <p className ='text-light'>Please enter a valid email address and a password</p>
                <form
                    name = 'credentials'
                    method = "POST"
                    encType = "multipart/form-data"
                    onSubmit = { handleSubmit }
                >
                    <div className ="form-floating my-3">
                        <input
                            className = {
                                "form-control " +
                                (
                                    status.type == STATUS_CHOICES.ERROR ?
                                        'is-invalid' :
                                        status.type == STATUS_CHOICES.SUCCESS ?
                                            'border border-2 border-success' :
                                            ''
                                )
                            }
                            type = "email"
                            name = "email"
                            placeholder = "Email"
                            maxLength = "254"
                            autoComplete = "email"
                            id = "email"
                            disabled = { status.type == STATUS_CHOICES.SUCCESS }
                            required 
                        />
                        <label htmlFor = 'email'>Email</label>
                    </div>
                    <div className ="form-floating my-2">
                        <input
                            className = {
                                "form-control " +
                                (
                                    status.type == STATUS_CHOICES.ERROR ?
                                        'is-invalid' :
                                        status.type == STATUS_CHOICES.SUCCESS ?
                                            'border border-2 border-success' :
                                            ''
                                )
                            }
                            type = "password"
                            name = "password"
                            placeholder = "Password"
                            autoComplete = "new-password"
                            id = "password"
                            disabled = { status.type == STATUS_CHOICES.SUCCESS }
                            required 
                        />
                        <label htmlFor = 'password'>Password</label>
                    </div>
                    <div className ="form-floating my-2">
                        <input
                            className = {
                                "form-control " +
                                (
                                    status.type == STATUS_CHOICES.ERROR ?
                                        'is-invalid' :
                                        status.type == STATUS_CHOICES.SUCCESS ?
                                            'border border-2 border-success' :
                                            ''
                                )
                            }
                            type = "password"
                            name = "password2"
                            placeholder = "Confirm password"
                            autoComplete = "new-password"
                            id = "password2"
                            disabled = { status.type == STATUS_CHOICES.SUCCESS }
                            required 
                        />
                        <label htmlFor = 'password2'>Confirm password</label>
                    </div>
                    <div className ="form-check form-switch fs-6 my-3">
                        <input
                            className = {
                                "form-check-input border-light" +
                                (
                                    status.type == STATUS_CHOICES.ERROR ?
                                        'is-invalid' :
                                        ''
                                )
                            }
                            type = "checkbox"
                            role = "switch"
                            name = "accept-terms"
                            id = "accept-terms"
                            disabled = { status.type == STATUS_CHOICES.SUCCESS }
                        />
                        <label className ='text-light' htmlFor = "accept_terms">
                            I accept the <a className ='link-light' href = { props.termsUrl }>terms and conditions</a>
                        </label>
                    </div>
                    <input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response" />
                    {
                        status.type == STATUS_CHOICES.WAITING ?
                            <div className = 'text-end'>
                                <div className = "spinner-border text-light" role = "status">
                                    <span className = "visually-hidden">Loading...</span>
                                </div>
                            </div> :
                            <div>
                                {
                                    status.type == STATUS_CHOICES.ERROR ?
                                        <ul className = "text-danger text-end list-unstyled fs-6">
                                            {
                                                status.messages.map((message, i) => {
                                                    return <li key = { i }>{ message }</li>;
                                                })
                                            }
                                        </ul> :
                                        null
                                }
                                {
                                    status.type == STATUS_CHOICES.SUCCESS ?
                                        <ul className = "text-success text-end list-unstyled fs-6">
                                            {
                                                status.messages.map((message, i) => {
                                                    return <li key = { i }>{ message }</li>;
                                                })
                                            }
                                        </ul> :
                                        null
                                }
                                {
                                    status.type == STATUS_CHOICES.IDLE || status.type == STATUS_CHOICES.ERROR ?
                                        <div className = "text-end my-3">
                                            <button className = "btn btn-outline-light" type = "submit">Create account</button>
                                        </div> :
                                        null
                                }
                            </div>
                    }
                </form>
            </div>
    </>;
};

RegisterApp.propTypes = {
    registerApiEndpoint: PropTypes.string,
    termsUrl: PropTypes.string,
};

export default RegisterApp;